import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDualSidedMidStreetCrossings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 322,
	height: 175,
	viewBox: "0 0 322 175",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 322,
			height: 175,
			rx: 8,
			fill: "#F2F2F2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.6161,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.6161,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 108.998,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 108.998,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 212.03,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 212.03,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64.3059,
			y: 21.5,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64.3059,
			y: 100.871,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 131.688,
			y: 21.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 131.688,
			y: 100.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.028,
			y: 21.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.028,
			y: 100.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 234.72,
			y: 21.5,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 234.72,
			y: 100.871,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86.3081,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86.3081,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 189.34,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 189.34,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.722,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.123,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.722,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.123,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 75L83.7584 75L149 75V21",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302 75L237.242 75L172 75V21",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149 154V100H130.5",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302 101L268.625 101L235 101",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45 101L32.0483 101L19 101",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131 76L131 88.9517L131 102",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.8861 48.1721L85.9813 73.914L98.0138 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 48.1721L42.0952 73.914L54.1277 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.8477 126.47L86.9429 100.729L98.9753 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 126.47L42.0952 100.729L54.1277 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.578 48.1721L130.673 73.914L142.706 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.54 126.47L131.635 100.729L142 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179 126.47L189.83 100.729L201.863 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.5 48.1721L188.869 73.914L200.901 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.929 126.47L235.024 100.729L247.056 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265 126.47L279.095 100.729L291.128 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.929 48.1721L235.024 73.914L247.056 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266 48.1721L280.095 73.914L292.128 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87 74L131 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190 74H234",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131 102L131 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 102L42 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189 102L189 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M280 102L280 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235 101L280 101",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 101L87 101",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M132.8 71C132.952 71 133.084 71.0934 133.152 71.2358L134.929 74.7472C134.977 74.8179 135.001 74.9075 135.001 75.0009C135.001 75.0943 134.977 75.183 134.929 75.2547L133.152 78.766C133.118 78.8377 133.068 78.8972 133.006 78.9387C132.944 78.9802 132.873 79.0019 132.801 79.0019H129.2C129.048 79.0019 128.916 78.9085 128.848 78.766L127.072 75.2538C127.024 75.183 127 75.0934 127 75C127 74.9066 127.024 74.8179 127.072 74.7462L128.848 71.2358C128.916 71.0934 129.049 71 129.201 71H132.801H132.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M134.351 74.8198L132.843 71.8387C132.786 71.7179 132.674 71.6387 132.544 71.6387H129.488C129.359 71.6387 129.247 71.7179 129.189 71.8387L127.681 74.8198C127.64 74.8802 127.62 74.9557 127.62 75.0349C127.62 75.1142 127.64 75.1896 127.681 75.25L129.189 78.2311C129.247 78.3519 129.359 78.4311 129.488 78.4311H132.544C132.606 78.4311 132.667 78.4132 132.719 78.3774C132.772 78.3425 132.815 78.2915 132.843 78.2311L134.351 75.25C134.392 75.1896 134.412 75.1142 134.412 75.0349C134.412 74.9557 134.392 74.8802 134.351 74.8198ZM129.588 72.2047H130.934L130.35 73.333L128.8 76.3302L128.149 75.0453L129.588 72.2047ZM132.444 77.8858H129.588L128.956 76.6396H133.075L132.443 77.8858H132.444ZM133.232 76.3302L131.098 72.2047H132.443L133.883 75.0453L133.231 76.3302H133.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M43.8 97C43.952 97 44.0836 97.0934 44.1524 97.2358L45.9287 100.747C45.9771 100.818 46.0008 100.908 46.0008 101.001C46.0008 101.094 45.9771 101.183 45.9287 101.255L44.1524 104.766C44.1184 104.838 44.0684 104.897 44.0064 104.939C43.9444 104.98 43.8731 105.002 43.8009 105.002H40.2C40.048 105.002 39.9164 104.908 39.8476 104.766L38.0722 101.254C38.0238 101.183 38 101.093 38 101C38 100.907 38.0238 100.818 38.0722 100.746L39.8484 97.2358C39.9164 97.0934 40.0488 97 40.2008 97H43.8009H43.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M45.3513 100.82L43.8433 97.8387C43.7856 97.7179 43.6735 97.6387 43.5445 97.6387H40.4878C40.3587 97.6387 40.2466 97.7179 40.1889 97.8387L38.6809 100.82C38.6402 100.88 38.6198 100.956 38.6198 101.035C38.6198 101.114 38.6402 101.19 38.6809 101.25L40.1889 104.231C40.2466 104.352 40.3587 104.431 40.4878 104.431H43.5445C43.6056 104.431 43.6667 104.413 43.7194 104.377C43.772 104.342 43.8153 104.292 43.8433 104.231L45.3513 101.25C45.392 101.19 45.4124 101.114 45.4124 101.035C45.4124 100.956 45.392 100.88 45.3513 100.82ZM40.588 98.2047H41.9338L41.3504 99.333L39.8 102.33L39.1488 101.045L40.588 98.2047ZM43.4443 103.886H40.588L39.9563 102.64H44.0751L43.4434 103.886H43.4443ZM44.2322 102.33L42.0976 98.2047H43.4434L44.8826 101.045L44.2314 102.33H44.2322Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M236.8 96C236.952 96 237.084 96.0934 237.152 96.2358L238.929 99.7472C238.977 99.8179 239.001 99.9075 239.001 100.001C239.001 100.094 238.977 100.183 238.929 100.255L237.152 103.766C237.118 103.838 237.068 103.897 237.006 103.939C236.944 103.98 236.873 104.002 236.801 104.002H233.2C233.048 104.002 232.916 103.908 232.848 103.766L231.072 100.254C231.024 100.183 231 100.093 231 100C231 99.9066 231.024 99.8179 231.072 99.7462L232.848 96.2358C232.916 96.0934 233.049 96 233.201 96H236.801H236.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M238.351 99.8198L236.843 96.8387C236.786 96.7179 236.674 96.6387 236.544 96.6387H233.488C233.359 96.6387 233.247 96.7179 233.189 96.8387L231.681 99.8198C231.64 99.8802 231.62 99.9557 231.62 100.035C231.62 100.114 231.64 100.19 231.681 100.25L233.189 103.231C233.247 103.352 233.359 103.431 233.488 103.431H236.544C236.606 103.431 236.667 103.413 236.719 103.377C236.772 103.342 236.815 103.292 236.843 103.231L238.351 100.25C238.392 100.19 238.412 100.114 238.412 100.035C238.412 99.9557 238.392 99.8802 238.351 99.8198ZM233.588 97.2047H234.934L234.35 98.333L232.8 101.33L232.149 100.045L233.588 97.2047ZM236.444 102.886H233.588L232.956 101.64H237.075L236.443 102.886H236.444ZM237.232 101.33L235.098 97.2047H236.443L237.883 100.045L237.231 101.33H237.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190.8 95C190.952 95 191.084 95.0934 191.152 95.2358L192.929 98.7472C192.977 98.8179 193.001 98.9075 193.001 99.0009C193.001 99.0943 192.977 99.183 192.929 99.2547L191.152 102.766C191.118 102.838 191.068 102.897 191.006 102.939C190.944 102.98 190.873 103.002 190.801 103.002H187.2C187.048 103.002 186.916 102.908 186.848 102.766L185.072 99.2538C185.024 99.183 185 99.0934 185 99C185 98.9066 185.024 98.8179 185.072 98.7462L186.848 95.2358C186.916 95.0934 187.049 95 187.201 95H190.801H190.8Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.351 98.8198L190.843 95.8387C190.786 95.7179 190.674 95.6387 190.544 95.6387H187.488C187.359 95.6387 187.247 95.7179 187.189 95.8387L185.681 98.8198C185.64 98.8802 185.62 98.9557 185.62 99.0349C185.62 99.1142 185.64 99.1896 185.681 99.25L187.189 102.231C187.247 102.352 187.359 102.431 187.488 102.431H190.544C190.606 102.431 190.667 102.413 190.719 102.377C190.772 102.342 190.815 102.292 190.843 102.231L192.351 99.25C192.392 99.1896 192.412 99.1142 192.412 99.0349C192.412 98.9557 192.392 98.8802 192.351 98.8198ZM187.588 96.2047H188.934L188.35 97.333L186.8 100.33L186.149 99.0453L187.588 96.2047ZM190.444 101.886H187.588L186.956 100.64H191.075L190.443 101.886H190.444ZM191.232 100.33L189.098 96.2047H190.443L191.883 99.0453L191.231 100.33H191.232Z",
			fill: "#E1373B"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(127 71)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(38 97)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(231 96)"
				})
			})
		] })
	]
});
export default SvgDualSidedMidStreetCrossings;
